<template>
  <div>
    <pt-modal :title="$t('user.modal.resetPassword')" :width="500" :closable="false" :visible="modal.visible" :loading="modal.loading">
      <div slot="content">
        <div style="margin-bottom: 20px;padding-left: 5px">
          <span style="font-size: 14px;color: #D23F3F">{{ $t('updatepasswordtips') }}</span>
        </div>
        <update-password ref="addModalForm" ></update-password>
      </div>
      <div slot="footer">
        <a-button type="primary"  :loading="modal.loading"  @click="handleOk">
          {{$t('baseVO.confirm')}}
        </a-button>
      </div>
    </pt-modal>
  </div>

</template>

<script>
import Api from '@/api/sys/account'
import { mapActions, mapGetters,mapState } from 'vuex'
import updatePassword  from './updatePassword'
export default {
  name: 'reUpdatePassword',
  components:{
    updatePassword
  },
  data(){
    return {
      visible:false,
      modal:{
        loading:false,
        visible:false,
      },
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info
    }),
  },
  mounted() {
    if(this.userInfo.isUpdatePassword){
      this.updatePassword();
    }
  },
  methods:{
    ...mapActions(['Logout']),
    handleCancel(){
      this.modal.visible = false
      this.modal.loading = false
    },
    updatePassword(){
      this.modal.visible = true
    },
    homePageOk(){
      this.homePageModal.loading = true;
      this.$refs.homePageModal.submit();
    },
    handleOk() {
      this.modal.loading = true
      //保存
      this.$refs.addModalForm.getData().then((datas) => {
        this.save(datas)
      }).catch(()=>{
        this.modal.loading = false
      })
    },
    save(datas){
      Api.updatePassword(datas).then(res=>{
        if(res.code == 1){
          this.$message.success(res.message)
          this.handleCancel()
          //修改密码,重新登录
          this.$warning({
            title:this.$t('user.loginTips.title'),
            content:this.$t('user.loginTips.content'),
            onOk:()=>{
              this.Logout({}).then(() => {
                setTimeout(() => {
                  window.location.reload()
                }, 16)
              }).catch(err => {

              })
            }
          })

        }else{
          this.modal.loading = false
        }
      })
    },
  }

}
</script>

<style lang="less">
.update_info{
  .title_div{
    background-image: url("~@/assets/update.png");
    height: 134px;
    background-size: cover;
    text-align: left;
    .title_content{
      display: flex;
      padding-left: 67px;
      flex-direction: column;
      height: 134px;
      justify-content: center;
      align-content: center;
      div:first-child{
        font-size: 24px;
        color: #FFFFFF;
      }
      div:last-child{
        padding-top: 8px;
        font-size: 12px;
        color: #999999;
      }
    }
  }

  .ant-modal-header{
    padding: 0px;
  }
  .ant-modal{
    top: 60px !important;
    padding-bottom: 0px !important;
  }
  .ant-modal-close-x{
    color: #ffffff;
    font-size: 20px !important;
  }
  .ant-modal-body{
    padding: 0px !important;
  }
  .content{
    height: 360px;
    padding: 35px 67px 0px;
    overflow-y: auto;
    .content_div{
      text-align: justify;
      .item{
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 15px;
      }
      .update_info_content{
        ol{
          margin-left: -25px;
          line-height: 15px;
        }
      }
    }
  }
}
</style>
